import React from 'react'; //  useState
import assets from 'assets';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import useMediaQuery from 'container/hooks/useMediaQuery';
// import CustomButton from 'container/components/CustomButton/CustomButton';

const Header = ({ setStep }) => {
  const dispatch = useDispatch();
  // const [value, setValue] = useState(3);

  const isMobile = useMediaQuery('(max-width: 1000px)');

  const open = useSelector(state => state.utils.openControls);

  const selectedConversation = useSelector(
    state => state.chat.selectedConversation
  );

  const toggleControls = () => {
    dispatch.utils.setOpenControls(!open);
  };

  const handleOpenLeftMenu = () => {
    dispatch.utils.setOpenMobileChatMenu(true);
  };

  const handleOpenRightMenu = () => {
    dispatch.utils.setOpenMobileRightMenu(true);
  };

  // const handleCustomPromptButtonClick = () => {
  //   setStep(2);
  // };

  // const handleChange = e => {
  //   const value = e.target.value;
  //   setValue(value);
  //   dispatch.imageGeneration.setGrid(value);
  // };

  return (
    <Container>
      <div className='title'>
        {isMobile && (
          <IconButton role='button' onClick={handleOpenLeftMenu}>
            <img src={assets.message} alt='' />
          </IconButton>
        )}
        {selectedConversation && (
          <p className='font-size-16 header'>{selectedConversation?.label}</p>
        )}
      </div>
      <div className='controls'>
        {/* {!isMobile && (
          <Slider>
            <p className='font-size-14 bold'>Columns</p>
            <input
              type='range'
              onChange={handleChange}
              value={value}
              name=''
              step={1}
              min={1}
              max={3}
              id=''
            />

            <div className='value-chip'>{value}</div>
          </Slider>
        )} */}
        <Button onClick={toggleControls} className='btn'>
          <img
            src={isMobile ? assets.settings : assets.chevronLeft}
            alt=''
            style={{
              transform: open ? 'rotate(0deg)' : '',
              transition: '0.6s ease',
            }}
          />
        </Button>
        {isMobile && (
          <IconButton role='button' onClick={handleOpenRightMenu}>
            <img src={assets.menu} alt='' />
          </IconButton>
        )}
      </div>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightgrey};
  padding: 11px;
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  & p {
    margin: 0px;

    &.header {
      width: 20ch;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  & .controls {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  & .title {
    display: flex;
    align-items: center;
    gap: 10px;

    & .edit-icon {
      cursor: pointer;
    }
  }

  & .btn {
    height: 30px;
    width: 30px;
    padding: 0px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    display: grid;
    place-items: center;
    transform: translateX(25px);
    background-color: ${({ theme }) => theme.colors.red};
    &:hover {
      background-color: ${({ theme }) => theme.colors.red};
    }
  }

  @media only screen and (max-width: 1000px) {
    & .controls {
      gap: 10px;
    }

    & .btn {
      height: 38px;
      width: 38px;
      display: grid;
      place-items: center;
      padding: 0px;
      border-radius: 8px;
      transform: translateX(0px);
    }
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background-color: ${({ theme }) => theme.colors.accent};
  padding: 0px 20px;
  height: 38px;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;

  & p {
    margin: 0px;
  }

  & img {
    transform: rotate(180deg);
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;
// eslint-disable-next-line
const Slider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & .value-chip {
    padding: 2px 15px;
    border-radius: 41px;
    background-color: ${({ theme }) => theme.colors.lightgrey};
    font-size: 10px;
    min-width: 37px;
  }
`;

const IconButton = styled.div`
  height: 38px;
  width: 38px;
  border-radius: 5px;
  display: grid;
  place-items: center;
  background-color: ${({ theme }) => theme.colors.lightgrey};
  cursor: pointer;
`;
